import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Master Department',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Department',
        href: '/adm/fin/master/department',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'department',
        label: 'Nama Department',
        sortable: true,
      },
      {
        key: 'pic',
        label: 'Penanggung Jawab',
      },
      {
        key: 'sector',
        label: 'Bidang',
      },
      {
        key: 'remark',
        label: 'Keterangan',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose_department: [
      {
        key: 'id_department',
        label: 'ID Department',
        sortable: true,
      },
      {
        key: 'department',
        label: 'Nama Department',
        sortable: true,
      },
      {
        key: 'pic',
        label: 'Penanggung Jawab',
      },
    ],
    detail: false,
    form: {
      id_pic: '',
      pic: '',
      id_department: '',
      department: '',
      sector: '',
      remark: '',
      id_parent_department: '',
      parent_department: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeDepartment(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchDepartment(context, params = null) {
    let result = await ApiGetRequest(`fin/department`, params);
    return !result.error ? result.data.object : [];
  },

  async getAllDepartment({ commit }) {
    commit('changeDepartment', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/department`);
    commit('changeDepartment', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListDepartment({ commit, state }) {
    commit('changeDepartment', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/department`, params);
    commit('changeDepartment', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailDepartment({ commit }, payload = null) {
    commit('changeDepartment', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/department/${payload.id}`);
    commit('changeDepartment', {
      loading: false,
    });

    if (!result.error) {
      commit('changeDepartment', {
        form: {
          ...result.data.object,
        },
      });
    }

    return result.error ? false : true;
  },

  async createDepartment({ commit, state, dispatch }) {
    commit('changeDepartment', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/department`, state.data.form);
    commit('changeDepartment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateDepartment({ commit, state, dispatch }, payload = null) {
    commit('changeDepartment', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/department/${payload.id}`,
      state.data.form
    );

    commit('changeDepartment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteDepartment({ commit, dispatch }, payload = null) {
    commit('changeDepartment', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/department/${payload.id}`);
    commit('changeDepartment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
